import { Divider, Menu } from 'antd'
import oGet from 'lodash/get'
import { inject, observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import routes from '../../router/routes'
import LabelMenu from '@/components/Label'
import sa from '../../utils/statis'

const getCount = (name: any, data: any) => {
  const dir = {
    Inbox: data.inboxCount,
    Outbox: data.outboxCount,
    Star: data.starCount,
    Sent: data.sentCount,
    Draft: data.draftCount,
    Trash: data.trashCount,
    Contact: data.contactCount,
  }
  return oGet(dir, name, 0)
}

const CustomMenu = (props: any) => {
  const { data: faxCountData } = props.faxUsageStore
  const userStore = props.userStore

  const handleMenu = (e: any) => {
    sa.Track('[panel]Menu_Click', { page: e.key })
  }

  const pathName = useMemo(() => {
    const path = props.history.location.pathname
    if (path.includes('profile')) {
      return '/page/profile'
    } else if (path.includes('contact')) {
      return '/page/contact'
    } else {
      return path
    }
  }, [props.history.location.pathname])

  const SubMenu = (props: any) => {
    return <div>{props.children}</div>
  }

  return (
    <Menu
      className="nav"
      defaultSelectedKeys={['/dashboard']}
      defaultOpenKeys={['/dashboard']}
      onClick={(e) => handleMenu(e)}
      selectedKeys={[pathName]}
      mode="inline"
    >
      {routes.map((c: any, index) => {
        if (c.name === 'Label') {
          return (
            // 用SubMenu包住可以解决警告，但是会造成LabelMenu会多次渲染
            // <SubMenu key="Label">
            <div
              key="Label"
              style={{ borderTop: '1px solid rgba(0,0,0,.06)', paddingTop: 6, marginTop: 10 }}
              onClick={() => handleMenu({ key: '/page/label' })}
            >
              <LabelMenu />
            </div>
            // </SubMenu>
          )
        }

        if (c.hideTab === true) {
          return null
        }

        if (c.role && typeof c.role === 'function') {
          if (!c.role(userStore)) {
            return null
          }
        }

        const title = c.title || c.name
        const count = getCount(c.name, faxCountData)
        const countText = count ? `(${count})` : ''
        return (
          <React.Fragment key={c.path}>
            {c.divider ? <Menu.Divider style={{ margin: '10px 0' }} /> : null}
            <Menu.Item title={title} key={c.path}>
              <Link style={{ display: 'flex', alignItems: 'center' }} to={{ pathname: c.path, state: { title } }}>
                {c.icon}
                <span>
                  {title}
                  {countText}
                </span>
              </Link>
            </Menu.Item>
          </React.Fragment>
        )
      })}
    </Menu>
  )
}

export default inject('faxUsageStore', 'userStore')(withRouter(observer(CustomMenu)))
